(async () => {
  if (!customElements.get('product-recommendations')) {
    const { Swiper } = await import('swiper');
    const { A11y, Navigation } = await import('swiper/modules');

    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-swiper]');

        this.swiperOptions = {
          modules: [A11y, Navigation],
          threshold: 10,
        };

        // Check if we have extra options on the HTML
        if (this.swiperElement.dataset && this.swiperElement.dataset.options) {
          const jsonOptions = JSON.parse(this.swiperElement.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions,
            };
          }
        }

        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

        // hide the whole section if there are no products to be shown (we are skipping the Embroidery logos so we have to have this extra check)
        if (this.querySelector('[data-recommended-products]').children.length == 0) {
          this.style.display = 'none';
        }

        // Only do it once, not on every web component render.
        window.onload = () => {
          this.init();
        };
      }

      init() {
        if (this.dataset && this.dataset.url && this.dataset.json) {
          // Fetch both resources in parallel
          Promise.all([
            fetch(this.dataset.json).then((response) => response.json()),
            fetch(this.dataset.url).then((response) => response.text()),
          ])
            .then(([jsonData, htmlText]) => {
              const { products } = jsonData;

              if (products && products.length > 0) {
                // Parse the HTML and update the recommended products
                const html = new DOMParser()
                  .parseFromString(htmlText, 'text/html')
                  .querySelector('[data-recommended-products]').innerHTML;

                this.querySelector('[data-recommended-products]').innerHTML = html;

                // Update the swiper instance
                this.swiperInstance.update();
                if (this.swiperOptions.navigation) {
                  this.swiperInstance.navigation.init();
                  this.swiperInstance.navigation.update();
                }

                this.classList.remove('hidden');
              } else {
                // No products found, hide the component
                this.classList.add('hidden');
              }
            })
            .catch((error) => {
              console.error('Error loading product recommendations:', error);
              this.classList.add('hidden');
            });
        }
      }
    }

    window.ProductRecommendations = ProductRecommendations;

    customElements.define('product-recommendations', ProductRecommendations);
  }
})();
